import styled from 'styled-components'

export const Checkbox = styled.div<{ colorScheme?: string, withBackground?: boolean }>`
  width: 100%;
  margin-right: ${({ theme }) => theme.rem(8)};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${({ theme }) => theme.rem(8)};


  input[type="checkbox"] {
    width: ${({ theme }) => theme.rem(24)};
    height: ${({ theme }) => theme.rem(24)};
    border: 1px solid ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
    margin: 0;
    transition: background-color .2s ease-in 0s;
    cursor: pointer;
    appearance: none;
    cursor: pointer;
   
    &:checked {
      background-color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
    }
  }

  label {
    cursor: pointer;
  }
`

export const CheckboxError = styled.div`
  padding-top: ${({ theme }) => theme.rem(8)};
  color: ${({ theme }) =>theme.colors.status.error.default};
  font-size: ${({ theme }) => theme.rem(12)};
`

export const CheckboxLabel = styled.label`
  font-size: ${({ theme }) => theme.rem(11)};
  line-height: ${({ theme }) => theme.rem(11)};
  margin-bottom: ${({ theme }) => theme.rem(10)};
  font-weight: bold;
`
